import { constants } from './Localization';

export enum HelpPanelTopicOptions {
    ADJUSTMENTS_ADD = 'adjustments_add',
    ADJUSTMENTS_EDIT = 'adjustments_edit',
    ADJUSTMENTS_VIEW = 'adjustments_view',
    ALL_PORTFOLIOS = 'all_portfolios',
    APPLICATION_COST_DETAILS = 'application_cost_details',
    APPLICATION_COST_SUMMARY = 'application_cost_summary',
    APPLICATION_GROUPS = 'application_groups',
    APPLICATION_OVERVIEW = 'application_overview',
    APPLICATION_PRIORITIZATION = 'application_prioritization',
    APPLICATION_RESOURCES = 'application_resources',
    ASSETS = 'assets',
    AWS_IT_AND_SUPPORT = 'aws_it_and_support',
    AWS_STORAGE_AND_NETWORK = 'aws_storage_and_network',
    CONTACT_MANAGEMENT = 'contact_management',
    CREATE_PORTFOLIO = 'create_portfolio',
    DASHBOARDS = 'dashboards',
    DATA_COLLECTION = 'data_collection',
    DATA_QUALITY = 'data_quality',
    DATA_QUALITY_CREATE_RULE = 'data_quality_create_rule',
    DATA_QUALITY_EDIT_RULE = 'data_quality_edit_rule',
    DEFAULT = 'default',
    DEPENDENCIES = 'dependencies',
    IMPORT_FROM_ADS = 'import_from_ads',
    IMPORT_FROM_FILE = 'import_from_file',
    EC2_COST = 'ec2_cost',
    EC2_RECOMMENDATIONS = 'ec2_recommendations',
    MAINFRAME_SUMMARY = 'mainframe_summary',
    MIGRATION_CASH_FLOW = 'migration_cash_flow',
    MIGRATION_COST_SUMMARY = 'migration_cost_summary',
    MIGRATION_STRATEGY = 'migration_strategy',
    ONPREM_DATABASE_COST = 'onprem_database_cost',
    ONPREM_IT_LABOR = 'onprem_it_labor',
    ONPREM_SERVER_COST = 'onprem_server_cost',
    ONPREM_STORAGE_AND_NETWORK = 'onprem_storage_and_network',
    PROPERTIES = 'properties',
    RDS_COST = 'rds_cost',
    RDS_RECOMMENDATIONS = 'rds_recommendations',
    SQL_SERVER_OPTIMIZATION = 'sql_server_optimization',
    TCO_SUMMARY = 'tco_summary',
    WAVE_PLANNING = 'wave_planning',
}

export enum RecentPortfoliosActions {
    ADD = 'ADD',
    REMOVE = 'REMOVE',
}

export enum DataQualityEnabledTypes {
    APPLICATION = 'application',
    DATABASE = 'database',
    SERVER = 'server',
}

export const DEFAULT_SPLIT_PANEL_SIZE = 300;

export const getSplitPanelI18NStrings = () => {
    return {
        preferencesTitle: constants.PREFERENCES_TITLE,
        preferencesPositionLabel: constants.PREFERENCES_POSITION_LABEL,
        preferencesPositionDescription: constants.PREFERENCES_POSITION_DESCRIPTION,
        preferencesPositionSide: constants.PREFERENCES_POSITION_SIDE,
        preferencesPositionBottom: constants.PREFERENCES_POSITION_BOTTOM,
        preferencesConfirm: constants.CONFIRM_BUTTON_TEXT,
        preferencesCancel: constants.CANCEL,
        closeButtonAriaLabel: constants.CLOSE_BUTTON_ARIA_LABEL,
        openButtonAriaLabel: constants.OPEN_BUTTON_ARIA_LABEL,
        resizeHandleAriaLabel: constants.RESIZE_HANDLE_ARIA_LABEL,
    };
};

export enum UniqueTourIdentifiers {
    FILE_IMPORT_TOUR = 'file_import_tour',
}

